module.exports = __webpack_public_path__ + "img/icon_chanp.875d6cfe.png";